import React from "react"
import { Result } from "antd"

const LABEL_SUBTITLE = "Sorry, page is not found."


const NotFoundPage = () => {
  return (
    <Result
      icon={false}
      title="404"
      subTitle={LABEL_SUBTITLE}
    />
  )
}

export default NotFoundPage
